import execute_on from "../../../libs/execute-on";
import hideVat from "../../../plugins/hide-vat-outside-ue/hide-vat-outside-ue"

execute_on('panel.company.edit', function () {
    hideVat("select2-country-container");
});

